<template>
    <!--弹窗-->
    <el-dialog
        v-if="dialogVisible"
        width="1400px"
        :title="pageType ==1 ? '运营asin生成' : pageType ==2 ? '运营asin查看' : '运营asin修改'"
        top="3vh"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
    >


        <el-form ref="formData" :inline="false" class="query-form" size="mini" :rules="rules" :model="formData"
                 :label-position="'right'" label-width="130px">

            <div class="wrapBox">
                <div class="boxItem">
                    <el-form-item label="数据核对：" class="query-form-item">
                    </el-form-item>

<!--                    <el-form-item label="FBA费用核对：" class="query-form-item">-->
<!--                        <el-select v-model="formData.check_fba_charge" placeholder="FBA费用核对" size="mini">-->
<!--                            <el-option :label="item.name" :value="item.value" v-for="item in collateArr"></el-option>-->
<!--                        </el-select>-->
<!--                    </el-form-item>-->
                    <el-form-item label="包装核对：" class="query-form-item">
                        <el-select v-model="formData.check_packing" placeholder="包装核对" size="mini">
                            <el-option :label="item.name" :value="item.value" v-for="item in collateArr"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标品类型：" class="query-form-item">
                        <el-select v-model="formData.standard_product_type" placeholder="标品类型" size="mini">
                            <el-option label="未录入" :value="-1"></el-option>
                            <el-option :label="item.name" :value="item.value"
                                       v-for="item in standardProductTypeArr"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="价格核对：" class="query-form-item">
                        <el-select v-model="formData.is_market_lowest_price" placeholder="价格核对" size="mini">

                            <el-option :label="item.name" :value="item.value" v-for="item in isLowPrice"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="vine情况：" class="query-form-item">
                        <el-select v-model="formData.vine_status" placeholder="vine情况" size="mini">
                            <el-option :label="item.name" :value="item.value" v-for="item in vineStatusArr"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="vine店铺：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.vine_shop" placeholder="请输入vine店铺"
                                  size="mini"></el-input>
                    </el-form-item>
                    <el-form-item label="备注：" class="query-form-item">
                        <el-input clearable v-model="formData.remark" placeholder="请输入备注" type="textarea" :rows="2"
                                  size="mini" style="width: 220px"></el-input>
                    </el-form-item>

                </div>

                <div class="boxItem">
                    <el-form-item label="广告情况：" class="query-form-item">
                    </el-form-item>
                    <el-form-item label="广告商铺：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.ad_shopname" placeholder="请输入广告商铺"
                                  size="mini" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="广告Asin：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.ad_asin" placeholder="请输入广告Asin"
                                  size="mini" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="广告MSKu：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.ad_msku" placeholder="请输入广告MSKu"
                                  size="mini" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="广告品名：" class="query-form-item">
                        <el-input style="width: 150px;" clearable v-model="formData.ad_product_name"
                                  placeholder="请输入广告品名"
                                  size="mini" disabled></el-input>
                    </el-form-item>

                    <el-button @click="openAdvertisingSituation" type="success" size="mini" style="margin-left: 100px">
                        更改
                    </el-button>

                    <el-form-item label="是否主卖：" class="query-form-item">
                        <el-radio-group v-model="formData.is_main_seller">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="是否铺货：" class="query-form-item">
                        <el-radio-group v-model="formData.is_launch">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>

                <div class="boxItem">


                    <el-form-item label="创建广告：" class="query-form-item">
                    </el-form-item>

                    <el-form-item label="是否创建Auto广告：" class="query-form-item" label-width="150px">
                        <el-radio-group v-model="formData.is_need_create_auto_ad">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item label="是否创建Skag广告：" class="query-form-item" label-width="150px">
                        <el-radio-group v-model="formData.is_need_create_skag_ad">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>



                    <el-form-item label="Auto创建时间：" class="query-form-item">
                        {{formData.auto_lastest_create_time}}
                    </el-form-item>

                    <el-form-item label="Skag关键词：" class="query-form-item">
                        <div class="tagBox">
                            <el-tag v-for="(tag, index) in formData.skag_keywords" @close="closeTag(tag, index)"
                                    :key="index" closable style="margin:0 10px 10px 0">
                                {{tag.keyword}} ({{tag.date}})
                            </el-tag>
                        </div>
                    </el-form-item>


                    <div class="createDiv">
                        <el-button @click="createAuto" type="primary" size="mini" class="autoBtn">
                            创建Auto广告
                        </el-button>
                        <el-button @click="createSkag" type="primary" size="mini" class="skagBtn">
                            创建Skag广告
                        </el-button>
                    </div>
                </div>
            </div>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary" size="mini">关 闭</el-button>
            <el-button @click="updateFunc" type="success" size="mini" v-show="pageType==3">修 改</el-button>
        </span>

        <advertisingSituation ref="advertisingSituation" @close-callback="closeCllback"></advertisingSituation>
        <addKeyWord ref="addKeyWord" @close-callback="addKeyWordCloseCllback"></addKeyWord>
    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import advertisingSituation from './advertisingSituation'
    import addKeyWord from './addKeyWord'
    import {downloadFileUrl} from '@/utils/method'

    export default {
        components: {advertisingSituation, addKeyWord},
        data() {
            return {
                vineStatusArr: [
                    {name: '未申请', value: '未申请'},
                    {name: '申请中', value: '申请中'},
                    {name: '完成', value: '完成'},
                    {name: '老品', value: '老品'},
                ],
                standardProductTypeArr: [
                    {name: '标品-大众', value: '标品-大众'},
                    {name: '标品-小众', value: '标品-小众'},
                    {name: '非标-大众', value: '非标-大众'},
                    {name: '非标-小众', value: '非标-小众'},
                ],
                collateArr: [
                    {name: '已核对', value: 1},
                    {name: '未核对', value: 0},
                ],
                isLowPrice: [
                    {name: '是', value: 1},
                    {name: '否', value: 0},
                ],

                expands: [],
                pageType: 1, // 1add 2preview 3update
                editSubIndex: 0,
                prodIndex: 0,
                rules: {
                    reference_id: [
                        {
                            required: true,
                            message: '请输入Reference ID',
                            trigger: 'blur'
                        },
                    ],
                },
                dialogVisible: false,
                isPreview: false,
                formData: {},
                previewInfo: {},
            }
        },
        methods: {
            closeTag(tag, index){
                this.formData.skag_keywords.splice(index, 1)
            },
            getCurrentDateTimeString() {
                const now = new Date();
                const year = now.getFullYear();
                const month = (now.getMonth() + 1).toString().padStart(2, '0');
                const day = now.getDate().toString().padStart(2, '0');
                const hours = now.getHours().toString().padStart(2, '0');
                const minutes = now.getMinutes().toString().padStart(2, '0');
                const seconds = now.getSeconds().toString().padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },
            createAuto() {
                api.operating_asin_manager_index_create_auto_ad({id: this.formData.id}).then((res) => {
                    if (res.success) {
                        this.downFile(res.data)
                        this.formData.auto_lastest_create_time = this.getCurrentDateTimeString()
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.message
                        })
                    }
                })
            },
            createSkag() {
                this.$refs.addKeyWord.openModal(this.formData.skag_keywords || [])
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: 'error',
                        message: '无法下载！'
                    })
                }
                downloadFileUrl(path)
            },
            getRowKeys(row) {
                return JSON.stringify(row)
            },
            clickRowHandle(row, expanded) {
                const tempItem = JSON.stringify(row)
                if (this.expands.includes(tempItem)) {
                    this.expands = this.expands.filter(val => val !== tempItem)
                } else {
                    this.expands.push(tempItem)
                }
            },
            openModal(type, data) {
                this.pageType = type
                data.skag_keywords = [null, 'null', ''].includes(data.skag_keywords) ? [] : JSON.parse(data.skag_keywords)
                this.formData = data
                this.dialogVisible = true
            },
            addKeyWordCloseCllback(obj) {
                if (obj.flag) {
                    api.operating_asin_manager_index_create_skag_ad({
                        id: this.formData.id,
                        keywords: JSON.stringify(obj.keyWord)
                    }).then((res) => {
                        if (res.success) {
                            let keyWords = obj.keyWord.map(item=>item.keyword)
                            let keywordArr = JSON.parse(JSON.stringify(this.formData.skag_keywords))
                            keywordArr = keywordArr.filter(item=>!keyWords.includes(item.keyword))
                            keywordArr = keywordArr.concat(obj.keyWord)
                            this.$set(this.formData, 'skag_keywords', keywordArr)
                            this.downFile(res.data)
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                }
            },
            closeCllback(obj) {
                if (obj.flag) {
                    let res = Object.assign(this.formData, obj.tempObj)
                    this.$set(this, 'formData', res)
                    this.updateFunc(false)
                }
            },
            showModal(data) {
                this.formData = data
                this.dialogVisible = true
            },
            // 关闭弹窗
            handleClose(flag = false) {
                console.log('---close dialog')
                this.$set(this, 'dialogVisible', false)
                this.dialogVisible = false
                console.log(this.dialogVisible)
                this.isPreview = false
                this.initFormData()
                this.$emit('close-callback', true)
            },
            openAdvertisingSituation() {
                this.$refs.advertisingSituation.openModal(JSON.parse(JSON.stringify(this.formData)))
            },
            updateFunc(flag=true) {
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        let tempFormData = JSON.parse(JSON.stringify(this.formData))
                        tempFormData.skag_keywords = JSON.stringify(tempFormData.skag_keywords)
                        api.operating_asin_manager_index_update_field(tempFormData).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message({message: '修改成功', type: 'success'})
                                flag && this.handleClose(true)
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(() => {
                            this.loading = false
                            this.$message({
                                type: 'error',
                                message: '网络出现问题，请刷新页面！'
                            })
                        })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            initFormData() {
                this.formData = {}
            }
        }
    }
</script>
<style type="text/scss" lang="scss" scoped>
    .el-table .success-row {
        background: #f0f9eb;
    }

    .createDiv {
        float: right;
        width: 120px;
        height: auto;
        margin-top: 30px;

        .autoBtn {
            margin-bottom: 10px;
        }

        .autoBtn, .skagBtn {
            float: right;
        }
    }

    .wrapBox {
        display: flex;
        flex-wrap: wrap;
        width: 1300px !important;

        .boxItem {
            width: 400px;
            box-shadow: inset 0px 1px 1px white, 0px 1px 3px rgba(0, 0, 0, 0.5);
            margin-right: 10px;
            padding: 10px;
            border-radius: 10px;

            .tagBox {
                height: 300px;
                overflow: auto;
            }
        }
    }
</style>

